import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../../modules/reports/maintenance_dob/violationsReportActions'
import * as api from '../../../api/reports/maintenance_dob/violationsReport'

function* violationsReportGetJobList(action) {
  try {
    const payload = yield call(api.getJobList, action.filters)
    yield put({ type: constants.VIOLATIONS_REPORT_GET_JOB_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.VIOLATIONS_REPORT_GET_JOB_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* violationsReportGetFullReport(action) {
  try {
    const payload = yield call(api.getFullReport, action.filters)
    yield put({ type: constants.VIOLATIONS_REPORT_GET_FULL_REPORT.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.VIOLATIONS_REPORT_GET_FULL_REPORT.FAILED,
      message: e.message || e
    })
  }
}

/**
 * Saga
 */

function* watchviolationsReportGetJobList() {
  yield takeLatest(constants.VIOLATIONS_REPORT_GET_JOB_LIST.ACTION, violationsReportGetJobList)
}

function* watchviolationsReportGetFullReport() {
  yield takeLatest(
    constants.VIOLATIONS_REPORT_GET_FULL_REPORT.ACTION,
    violationsReportGetFullReport
  )
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([fork(watchviolationsReportGetFullReport), fork(watchviolationsReportGetJobList)])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/reports/maintenance_dob/violationsReportSaga.js